import _mapCacheClear_default from "./_mapCacheClear.js";
import _mapCacheDelete_default from "./_mapCacheDelete.js";
import _mapCacheGet_default from "./_mapCacheGet.js";
import _mapCacheHas_default from "./_mapCacheHas.js";
import _mapCacheSet_default from "./_mapCacheSet.js";

//#region ../../node_modules/lodash-es/_MapCache.js
/**
* Creates a map cache object to store key-value pairs.
*
* @private
* @constructor
* @param {Array} [entries] The key-value pairs to cache.
*/
function MapCache(entries) {
	var index = -1, length = entries == null ? 0 : entries.length;
	this.clear();
	while (++index < length) {
		var entry = entries[index];
		this.set(entry[0], entry[1]);
	}
}
MapCache.prototype.clear = _mapCacheClear_default;
MapCache.prototype["delete"] = _mapCacheDelete_default;
MapCache.prototype.get = _mapCacheGet_default;
MapCache.prototype.has = _mapCacheHas_default;
MapCache.prototype.set = _mapCacheSet_default;
var _MapCache_default = MapCache;

//#endregion
export { _MapCache_default as default };
//# sourceMappingURL=_MapCache.js.map